module.exports = __webpack_public_path__ + "static/media/path0201.c379600e.jpg";